/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

import type { ZerogDailyStorageInfo } from './ZerogDailyStorageInfo';

export type ZerogHomeTotalStorageInfo = {
    STGHTP: ZerogHomeTotalStorageInfo.STGHTP;
    DAVGTRXC: string;
    CNGP: string;
    DSTGLIST: Array<ZerogDailyStorageInfo>;
};

export namespace ZerogHomeTotalStorageInfo {

    export enum STGHTP {
        DAY = 'DAY',
        WEEK = 'WEEK',
        MONTH = 'MONTH',
        QUARTER = 'QUARTER',
    }


}

